import React from "react";
import { bool, node, string } from "prop-types";
import { classes } from "@insightfulscience/atomic-react/utils/classes";
import { sxClassName } from "@insightfulscience/atomic-react/props/sx";
import { spacingClassName } from "@insightfulscience/atomic-react/props/spacing";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";

export const CardListTitle = ({ children }) => {
	return (
		<Paragraph
			spacing={{ mt: 0, pb: 2 }}
			utility={{ border: { bottom: { width: 1, color: "1" } } }}
		>
			{children}
		</Paragraph>
	);
};

CardListTitle.propTypes = {
	children: string.isRequired,
};

export const CardListItem = ({ children }) => {
	return <li className="li ul__li text-m mb-2">{children}</li>;
};

CardListItem.propTypes = {
	children: string.isRequired,
};

const CardList = ({ isListPros = true, children }) => {
	return (
		<ul
			className={classes(
				"ul",
				isListPros ? "ul-check" : "ul-no-check",
				...sxClassName({ fontSize: "m" }),
				...spacingClassName({ mt: 2, mb: 10 }),
			)}
		>
			{children}
		</ul>
	);
};

CardList.propTypes = {
	isListPros: bool,
	children: node.isRequired,
};

CardList.Title = CardListTitle;
CardList.Item = CardListItem;

export default CardList;
